import { css } from "@emotion/core";

import { color, fontSizes, fonts } from "../../../theme/Theme";

export const statusCardStyles = css({
  ".subsection-title": {
    fontSize: fontSizes.title,
    textAlign: "center"
  },
  ".status-image": {
    borderRadius: "0.25rem"
  },
  ".status-image--disabled": {
    opacity: 0.3,
    background: color.placeholder
  },
  ".image-and-label, .receivables-footer": {
    textAlign: "center"
  },
  ".hide-overflow": {
    overflow: "hidden"
  }
});

export const modalStyles = css({
  ".ant-modal-header": {
    backgroundColor: color.primary
  },
  ".ant-modal-footer": {
    border: "none"
  },
  ".receivable-amount": {
    fontFamily: fonts.bold,
    fontSize: fontSizes.title
  }
});
